import React from 'react'
import enterpriseApi from '../../../store/reducers/enterprise/enterpriseApi'
import { Suspense, lazy, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Enterprise2 } from '../../../interfaces/enterprise/enterprise_2'
import { Helmet } from 'react-helmet'
import { IContentCard } from '../../../interfaces/enterprise/argsApi'

import { isMobile, isValidStr } from '../../../common_functions'
import NewCarouselEnterprise from '../../../components/Carousels/NewCarouselEnterprise'
import SecionRecommendedEnterprises from '../../../components/Sections/SecionRecommendedEnterprises'
import {
  INFOS_CARD_SELECTED_ENTERPRISE,
  RECENTS_VIEWED_ENTERPRISES,
  VIEWED_ENTERPRISES
} from '../../../constants/storageNames'
import CarouselEnterpriseModalMobileTest from '../../../components/InternEnterpriseTest/CarouselEnterpriseModalMobileTest'
import NewCarouselEnterpriseTest from '../../../components/InternEnterpriseTest/NewCarouselEnterpriseTest'
import CardEnterpriseInternInfosPriceTest from '../../../components/InternEnterpriseTest/CardEnterpriseInternInfosPriceTest'
import Header from '../../../components/InternEnterpriseTest/Header'
import NavInternEnterpriseTest from '../../../components/InternEnterpriseTest/NavInternEnterpriseTest'
import { InternEnterpriseInit } from '../../../components/InternEnterpriseTest/InternEnterpriseInit'
import { Footer } from '../../../components'
import HeaderMobile from '../../../components/HeaderMobile'

const HeaderLayout = lazy(() => import('../../../components/Header'))
const CardEnterpriseInternInfosPrice = lazy(
  () => import('../../../components/Cards/CardEnterpriseInternInfosPrice')
)
const Error = lazy(() => import('../../../components/Error'))
const SkeletonLoading = lazy(() => import('../../../components/common/SkeletonLoading'))

interface Props {
  isLoadingFull?: boolean
}
export function InternEnterpriseTest({ isLoadingFull = true }: Props) {
  const [enterpriseGeneralInfos, setenterpriseGeneralInfos] = useState<Enterprise2>()
  const [useEnterprises, { data, isError, isLoading, isSuccess }] =
    enterpriseApi.useGetCardsEnterprisesMutation()
  const slug =
    location.pathname
      .replace('/empreendimentos/', '')
      .replace('/empreendimentos-a/', '')
      .toString() ?? ''
  const campaign = new URLSearchParams(location.search).get('campanha')

  const {
    data: dataEnterpriseData,
    isError: isErrorEnterpriseData,
    isLoading: isLoadingEnterpriseData,
    isSuccess: isSuccessEnterpriseData
  } = enterpriseApi.useGetEnterpriseDataBySlugQuery(
    location.pathname
      .replace('/empreendimentos/', '')
      .replace('/empreendimentos-a/', '')
      .toString() ?? ''
  )

  const listStorage = JSON.parse(localStorage.getItem(VIEWED_ENTERPRISES) ?? '[]')
  const [recentsViewedEnterprises, setrecentsViewedEnterprises] = useState<string[]>(
    JSON.parse(sessionStorage.getItem(RECENTS_VIEWED_ENTERPRISES) ?? '[]')
  )

  const [
    useViewedEnterprises,
    { isSuccess: isSuccessViewed, isError: isErrorViewed, isLoading: isLoadingViewed }
  ] = enterpriseApi.useAddViewedEnterpriseMutation()

  const setViewed = async () => {
    await useViewedEnterprises(dataEnterpriseData?.Data.Id ?? '')
  }

  useEffect(() => {
    if (enterpriseGeneralInfos === undefined && isLoadingFull) {
      getEnterprises()
    }
  }, [isLoadingFull])

  useEffect(() => {
    if (isSuccessViewed) {
      addStorageSlug()
    }
  }, [isSuccessViewed])

  const addStorageSlug = () => {
    if (isValidStr(slug)) {
      let list: Array<string> = []
      const listStorage = localStorage.getItem(VIEWED_ENTERPRISES)
      list = JSON.parse(listStorage ?? '[]')
      list.push(slug ?? '')

      localStorage.setItem(VIEWED_ENTERPRISES, listToStr(list))
    }
  }

  useEffect(() => {
    sessionStorage.setItem(
      RECENTS_VIEWED_ENTERPRISES,
      JSON.stringify(recentsViewedEnterprises ?? '[]')
    )
  }, [recentsViewedEnterprises])

  const addStorageRecentsViewed = () => {
    const id = dataEnterpriseData?.Data.Id
    if (id != undefined && !recentsViewedEnterprises.includes(id)) {
      setrecentsViewedEnterprises((prevState) => [...prevState, id])
    }
  }

  const listToStr = (list: string[]) => {
    let str = '['
    list?.forEach((element, index) => {
      str += `"${element}"`
      if (index != list.length - 1) str += ','
    })
    str += ']'
    return str
  }

  useEffect(() => {
    if (isSuccessEnterpriseData && isLoadingFull) {
      if (!listStorage.includes(slug)) setViewed()
      addStorageRecentsViewed()
    }
  }, [isSuccessEnterpriseData, isLoadingFull])

  const getEnterprises = async () => {
    const content: IContentCard = {
      stateId: null,
      cityId: null,
      statusId: null,
      districtId: null,
      priceMaximumValue: null,
      priceMinimumValue: null,
      numberOfRooms: null
    }
    await useEnterprises(content)

    if (!isError && !isLoading && data != undefined) {
      let dataBySlug = data.Data.filter((item: Enterprise2) => item.Slug == slug)
      setenterpriseGeneralInfos(dataBySlug.length > 0 ? dataBySlug[0] : undefined)
    }
  }

  const getCityLocation = () => {
    const endereco = dataEnterpriseData?.Data?.Location ?? ""
    const partes = endereco.split(',').map((p) => p.trim())

    const cidade = partes[partes.length - 3]
    return cidade ?? ""
  }

  return (
    <>
      {isLoadingFull ? (
        <>
          {window.innerWidth > 1029 ? (
            <HeaderLayout isFixed={false} />
          ) : (
            <HeaderMobile isFixed={false} hiddenFilterSearch />
          )}
          <div className={`md:-mt-[13px] -mt-[47px]`}>
            {
              <div className="lg:pt-5">
                <Helmet>
                  {/* <title>glemO | {dataEnterpriseData?.Data?.Title ?? ''}</title> */}
                  <title>
                    {dataEnterpriseData?.Data?.Title ?? ''} – empreendimento em{' '}
                    {getCityLocation()} pela GlemO
                  </title>
                  <link rel="canonical" href={window.location.href} />
                </Helmet>
                {isLoadingEnterpriseData && <SkeletonLoading height={400} />}
                {isSuccessEnterpriseData ? (
                  <>
                    <Suspense fallback={<SkeletonLoading />}>
                      <div className="px-5 lg:hidden">
                        <CarouselEnterpriseModalMobileTest
                          StatusId={dataEnterpriseData?.Data?.StatusId}
                          EnterpriseId={dataEnterpriseData?.Data.Id}
                        />
                      </div>
                      <div className="hidden lg:block">
                        <NewCarouselEnterpriseTest
                          StatusId={dataEnterpriseData?.Data?.StatusId}
                          EnterpriseId={dataEnterpriseData?.Data.Id}
                        />
                      </div>
                    </Suspense>
                    <section className="container-intern-enterprise gap-4 lg:mt-10">
                      <div className="lg:grid lg:grid-cols-3">
                        <div className="lg:col-span-3">
                          <div className="lg:grid lg:grid-cols-3">
                            {/* INFORMACOES  */}
                            <div className="lg:pl-10 order-2">
                              <Suspense fallback={<SkeletonLoading />}>
                                <CardEnterpriseInternInfosPriceTest
                                  ConstructionId={
                                    dataEnterpriseData?.Data?.ConstructionCompanyId ?? ''
                                  }
                                  CampaignId={campaign}
                                  EnterpriseId={dataEnterpriseData?.Data?.Id ?? ''}
                                  Price={dataEnterpriseData?.Data?.PriceMinimumValue}
                                  CompanyName={dataEnterpriseData?.Data?.ConstructionCompany}
                                  LogoUrl={dataEnterpriseData?.Data?.ConstructionCompanyLogoUrl}
                                  LastPublish={dataEnterpriseData?.Data?.LastPublish}
                                  DescriptionCompany={
                                    dataEnterpriseData?.Data?.ConstructionCompanyDescription
                                  }
                                />
                              </Suspense>
                            </div>
                            <div
                              className="lg:col-span-2 lg:pr-10 mt-3 lg:mt-auto"
                              id="detailsInternEnterprise"
                              style={{ overflowWrap: 'break-word' }}
                            >
                              <div>
                                <div className="container-responsive-view-mob">
                                  {/* HEADER */}
                                  <Suspense fallback={<SkeletonLoading />}>
                                    <Header enterprise={dataEnterpriseData?.Data} />
                                  </Suspense>
                                </div>
                                <NavInternEnterpriseTest enterprise={dataEnterpriseData?.Data} />
                              </div>
                            </div>
                          </div>
                          {/* RELACIONADOS */}
                          <div className="container-responsive-view-mob">
                            <SecionRecommendedEnterprises
                              enterpriseId={dataEnterpriseData?.Data.Id}
                            />
                          </div>
                        </div>
                      </div>
                    </section>
                  </>
                ) : (
                  <>
                    {isErrorEnterpriseData ? (
                      <>
                        <Error
                          typeError="500"
                          descriptionError="Fique tranquilo, estamos cientes e trabalhando para criar algo melhor.
            Sugerimos que você tente atualizar a página novamente, se o erro persistir, tente novamente mais tarde."
                        />
                      </>
                    ) : (
                      <div className={`${isMobile() ? 'mt-[13rem]' : ''}`}>
                        <div id="loadingBox"></div>
                      </div>
                    )}
                  </>
                )}
              </div>
            }
          </div>
          <Footer />
        </>
      ) : (
        <div className="mt-[150px]">
          <InternEnterpriseInit
            dataEnterprise={dataEnterpriseData?.Data}
            isLoadingEnterpriseData={isLoadingEnterpriseData}
            isSuccessEnterpriseData={isSuccessEnterpriseData}
          />
        </div>
      )}
    </>
  )
}
